import Api from "./base/api-base";

export default class WorkerDailyReportBulkApi {

  list(start_date, end_date, construction_id, department_id, management_user_id, worker_user_id) {
    return Api.link.get({
      links: [
        {endpoint: Api.endpoint.worker_daily_report_bulk},
        {endpoint: "/start", id: start_date},
        {endpoint: "/end", id: end_date},
        {endpoint: "/construction", id: construction_id},
        {endpoint: "/department", id: department_id},
        {endpoint: "/management", id: management_user_id},
        {endpoint: "/worker", id: worker_user_id},
      ]
    });
  }

  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.worker_daily_report_bulk,
      id: id,
      params: params
    });
  }
}
